import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectedFilters = _resolveComponent("SelectedFilters")!
  const _component_DisciplineFilter = _resolveComponent("DisciplineFilter")!
  const _component_EducationLevelFilter = _resolveComponent("EducationLevelFilter")!
  const _component_LocationFilter = _resolveComponent("LocationFilter")!
  const _component_TuitionFeeFilter = _resolveComponent("TuitionFeeFilter")!
  const _component_DurationFilter = _resolveComponent("DurationFilter")!
  const _component_FormatFilter = _resolveComponent("FormatFilter")!
  const _component_AttendanceFilter = _resolveComponent("AttendanceFilter")!
  const _component_SpecialProgrammesFilter = _resolveComponent("SpecialProgrammesFilter")!
  const _component_SearchFilterContainer = _resolveComponent("SearchFilterContainer")!

  return (_openBlock(), _createBlock(_component_SearchFilterContainer, null, {
    default: _withCtx(() => [
      _createVNode(_component_SelectedFilters),
      _createVNode(_component_DisciplineFilter),
      _createVNode(_component_EducationLevelFilter),
      _createVNode(_component_LocationFilter),
      _createVNode(_component_TuitionFeeFilter),
      _createVNode(_component_DurationFilter),
      _createVNode(_component_FormatFilter),
      _createVNode(_component_AttendanceFilter),
      _createVNode(_component_SpecialProgrammesFilter)
    ]),
    _: 1 /* STABLE */
  }))
}